<template>
  <main class="page-wellbeing container-fluid">
    <div v-if="loading" class="loading"></div>
    <div v-else class="row row-main">
      <div class="col col-1">
        <h2 class="font-size-xxl color-blue-1">{{columnText.label}}</h2>
        <div v-html="columnText.body"></div>
      </div>

      <div class="col col-2">
        <div class="menu-ball" :class="{opened: menuOpened}">
          <MenuBall ref="ball_0" :config="menuItems[0]" @itemShown="onItemShown" @itemHidden="onItemHidden" />
          <MenuBall ref="ball_1" :config="menuItems[1]" @itemShown="onItemShown" @itemHidden="onItemHidden" />
          <MenuBall ref="ball_2" :config="menuItems[2]" @itemShown="onItemShown" @itemHidden="onItemHidden" />
          <MenuBall ref="ball_3" :config="menuItems[3]" @itemShown="onItemShown" @itemHidden="onItemHidden" />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import PageBaseMixin from '@/mixins/PageBase';

import MenuBall from '@/components/MenuBall';

export default {
  components: {MenuBall},
  mixins: [PageBaseMixin],
  title: 'Somos Bienestar | Escuela de liderazgo',

  data() {
    return {
      loading: true,
      menuOpened: false,
      
      intro: {
        label: 'Bienestar y desarrollo personal',
        body: '<p>El liderazgo depende sustancialmente de una serie de habilidades personales que llevan a considerar el bienestar (emocional y físico) como una pieza clave para el fortalecimiento. </p><p>Esto, más allá de simples alusiones a mantener siempre una ‘actitud positiva’, se relaciona con la autoconciencia frente a la complejidad de situaciones que se presentan en la cotidianidad de la escuela. Así, es posible saber que en ocasiones no puede lograrse ‘todo lo proyectado’, que no pueden conocerse ‘todos los temas’ ni ‘resolverse todos los problemas’ que existen; por lo tanto, hay situaciones que se escapan de nuestro control, y que hay momentos donde resulta más valioso hacer ‘un alto en el camino’ y pausar el cuerpo y la mente para poner los asuntos en perspectiva.</p><p>Por eso, el componente de Bienestar y desarollo centra su atención en la autoconciencia, el manejo de las emociones, la comunicación asertiva y el trabajo colaborativo, como prácticas de liderazgo que tienen efectos en los directivos para conseguir un estilo de vida saludable y fortalecer el propósito de vida y desarrollo socioemocional.</p>',
      },

      columnText: {
        label: 'Bienestar y desarrollo personal',
        body: '<p>El liderazgo depende sustancialmente de una serie de habilidades personales que llevan a considerar el bienestar (emocional y físico) como una pieza clave para el fortalecimiento. </p><p>Esto, más allá de simples alusiones a mantener siempre una ‘actitud positiva’, se relaciona con la autoconciencia frente a la complejidad de situaciones que se presentan en la cotidianidad de la escuela. Así, es posible saber que en ocasiones no puede lograrse ‘todo lo proyectado’, que no pueden conocerse ‘todos los temas’ ni ‘resolverse todos los problemas’ que existen; por lo tanto, hay situaciones que se escapan de nuestro control, y que hay momentos donde resulta más valioso hacer ‘un alto en el camino’ y pausar el cuerpo y la mente para poner los asuntos en perspectiva.</p><p>Por eso, el componente de Bienestar y desarollo centra su atención en la autoconciencia, el manejo de las emociones, la comunicación asertiva y el trabajo colaborativo, como prácticas de liderazgo que tienen efectos en los directivos para conseguir un estilo de vida saludable y fortalecer el propósito de vida y desarrollo socioemocional.</p>',
      },
      // ballsRef: [],
      menuItems: [],
    }
  },

  methods: {

    hideAll(){
      for(let i=4;i--;){
        this.$refs['ball_' + i].hideChild();
      }
    },

    onItemHidden(){
      this.columnText.label = this.intro.label.replace('<br>', '');
      this.columnText.body = this.intro.body;
      this.menuOpened = false;
    },

    onItemShown(config){
      this.menuOpened = true;
      this.hideAll();
      this.columnText.label = config.label.replace('<br>', ' ');
      this.columnText.body = config.body;
    },

    async loadContent(){
      try{
        // this.loading = true;
        const req1 = await this.$api.get('/v1/wellbeing');
        // const menu = req1.rows;
        
        const req2 = await this.$api.get('/v1/wellbeing-child');

        const menu = req1.body.rows;
        let c = 1;
        let colors = ['','purple-1','blue-2','purple-1','blue-1'];
        
        menu.forEach(v => {
          v.color = colors[c];
          v.className = 'ball-' + c++;
          v.children  = req2.body.rows.filter(w => w.id_parent == v.id);
        });

        this.menuItems = menu;

      } finally {
        this.loading = false;
      }
    }
  },

  created(){
    this.loadContent();
  }
}
</script>